import { symbol } from "d3";
import { memo, useCallback, useState, useMemo, useRef } from "react";
import { isNumber } from "lodash";
import {
  DEFAULT_SIZE,
  DOT_SHAPE,
  XS_SHAPE,
  shapesObject,
  shapeSizeObject,
} from "../../constants";
import { hasAttribute } from "../../helper";
import { useFloating, autoPlacement, offset, arrow } from "@floating-ui/react"; // Floating UI
import { useTooltipCircle } from "../Tooltip/ScatterChart/useTooltip";

import "./styles.scss";
import { createPortal } from "react-dom";

const NodeComponent = (props) => {
  const {
    shape = DOT_SHAPE,
    size = DEFAULT_SIZE,
    color,
    cx,
    cy,
    dataTestId = "",
    visibility,
    highLightOnHover = false,
    data = {},
    defaultHoverSize = 60,
    tooltip
  } = props;

  const [hoverSize, setHoverSize] = useState(0);
  const [isTooltipVisible, setIsTooltipVisible] = useState(tooltip?.visibleOnInitial);
  const qtId = useRef(Math.round(Math.random() * 100000000));
  const arrowRef = useRef(null);

  const shapeObject = hasAttribute(shapesObject, shape)
    ? shapesObject?.[shape]
    : shapesObject?.[DOT_SHAPE];

  const elementSize = hasAttribute(shapeSizeObject, size)
    ? shapeSizeObject?.[size]
    : shapeSizeObject?.[DEFAULT_SIZE];

  const elementShape = shapeObject?.shape;

  const pathD = symbol().size(elementSize + hoverSize).type(elementShape)();

  const { refs, floatingStyles } = useFloating({
    placement: "top",
    middleware: [offset(10), autoPlacement(), arrow({ element: arrowRef })],
  });

  const { handleMouseOver: qtHandleMouseOver, handleMouseLeave: qtHandleMouseLeave } = useTooltipCircle(
    cx,
    cy,
    4,
    { ...data, qtId: qtId.current }
  );

  const onMouseOver = useCallback(() => {
    highLightOnHover && setHoverSize(defaultHoverSize);
    setIsTooltipVisible(true);
    qtHandleMouseOver();
  }, [highLightOnHover, defaultHoverSize]);

  const onMouseLeave = useCallback(() => {
    highLightOnHover && setHoverSize(0);
    setIsTooltipVisible(false);
    qtHandleMouseLeave();
  }, [highLightOnHover]);

  const xsShape = shape === XS_SHAPE;

  const transform = useMemo(() => {
    if (isNumber(cx) && isNumber(cy)) {
      return `translate(${cx}, ${cy})`;
    } else {
      return "";
    }
  }, [cx, cy]);

  return (
    <>
      <path
        ref={refs.setReference}
        className={highLightOnHover ? "node-highlight" : ""}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        transform={`${transform} ${xsShape ? "rotate(45)" : ""}`}
        d={pathD}
        fill={color}
        data-testid={dataTestId}
        visibility={visibility}
      />

      {isTooltipVisible && tooltip && (
        createPortal(<div
          ref={refs.setFloating}
          style={{
            ...floatingStyles, background: "red", color: "white", padding: "6px 10px", borderRadius: "4px", fontSize: "12px", fontWeight: "bold",
            // whiteSpace: "nowrap", 
            width: "150px",
            zIndex: 1002
          }}
        >
          <>{tooltip?.data?.message}</>
        </div>, document.body)
      )}
    </>
  );
};

export default memo(NodeComponent);